export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pagination.vue?vue&type=template&id=4f13556a&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/pagination/pagination.vue?vue&type=template&id=4f13556a&
// module id = 995
// module chunks = 0